// collections tab
if (!customElements.get('tab-collection-component')) {
  customElements.define('tab-collection-component', class SwiperTabs extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.id;
      this.tabClickHandler = this.onTabClick.bind(this);
      this.cache = {};
    }

    connectedCallback() {
      this.buttons.forEach(button => button.addEventListener('click', this.tabClickHandler));
    }

    async onTabClick(event) {
      const button = event.currentTarget;
      if (button.classList.contains('active') || button.classList.contains('is-loading')) return;

      const targetId = button.dataset.tabButton;
      const blockId = button.dataset.blockId;
      const targetContent = this.querySelector(`[data-tab-content="${targetId}"]`);
      const innerContainer = targetContent.querySelector('.tab_content--inner');

      this.clearActives(this.buttons);
      this.clearActives(this.contents);
      button.classList.add('active');
      targetContent.classList.add('active');

      if (targetContent.querySelector('swiper-collection-component')) return;

      // 1. Check if we already have the data (Cache) or if it's already rendered
      if (this.cache[blockId]) {
        innerContainer.innerHTML = '';
        innerContainer.appendChild(this.cache[blockId]);
        return; // Stop here! No fetch needed.
      }

      // 2. If empty, Fetch from Shopify Section Rendering API
      button.classList.add('is-loading');

      try {
        // We call the collection page but only ask for the specific section and block
        const url = `/collections/${innerContainer.dataset.collectionHandle}?section_id=${this.sectionId}&view=ajax`;
        const response = await fetch(url);
        const rawHtml = await response.text();

        const parser = new DOMParser();
        const html = parser.parseFromString(rawHtml, 'text/html');

        const newSwiperCollectionComponent = html.querySelector('swiper-collection-component');

        if (newSwiperCollectionComponent) {
          this.cache[blockId] = newSwiperCollectionComponent;

          innerContainer.innerHTML = '';
          innerContainer.appendChild(newSwiperCollectionComponent);
        }
      } catch (e) {
        console.error("Shopify AJAX Error:", e);
      } finally {
        button.classList.remove('is-loading');
      }
    }

    clearActives(items) {
      items.forEach(item => item.classList.remove('active'));
    }

    get buttons() { return this.querySelectorAll('[data-tab-button]'); }
    get contents() { return this.querySelectorAll('[data-tab-content]'); }
  });
}